export const READ_RS_TEMPLATES = 'READ_RS_TEMPLATES';
export const CREATE_RS_TEMPLATE = 'CREATE_RS_TEMPLATE';
export const UPDATE_RS_TEMPLATE = 'UPDATE_RS_TEMPLATE';
export const DELETE_RS_TEMPLATE = 'DELETE_RS_TEMPLATE';

export const readRsTemplatesAction = (templates, queryId = 'default') => ({
  type: READ_RS_TEMPLATES,
  payload: { templates, queryId },
});

export const createRsTemplateAction = (template, queryId = 'default') => ({
  type: CREATE_RS_TEMPLATE,
  payload: { template, queryId },
});

export const updateRsTemplateAction = (template, queryId = 'default') => ({
  type: UPDATE_RS_TEMPLATE,
  payload: { template, queryId },
});

export const deleteRsTemplateAction = (templateId, queryId = 'default') => ({
  type: DELETE_RS_TEMPLATE,
  payload: { templateId, queryId },
});

const initialState = { default: {} };

export function reportScheduleTemplates(state = initialState, action) {
  switch (action.type) {
    case READ_RS_TEMPLATES: {
      const newState = {
        ...state,
        [action.payload.queryId]: { ...state[action.payload.queryId] },
      };
      action.payload.templates.forEach((t) => {
        newState[action.payload.queryId][t._id] = t;
      });
      return newState;
    }
    case CREATE_RS_TEMPLATE:
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.template._id]: action.payload.template,
        },
      };
    case UPDATE_RS_TEMPLATE: {
      const current =
        (state[action.payload.queryId] &&
          state[action.payload.queryId][action.payload.template._id]) ||
        undefined;
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.template._id]: {
            ...current,
            ...action.payload.template,
          },
        },
      };
    }
    case DELETE_RS_TEMPLATE: {
      const { templateId } = action.payload;
      return Object.entries(state).reduce((prev, [key, val]) => {
        prev[key] = {
          ...val,
          [templateId]: undefined,
        };
        return prev;
      }, {});
    }
    default:
      return state;
  }
}
